var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelfastTaxiTourTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eb1b7;}.cls-2{fill:#5dc6d1;}.cls-3{fill:#6c6b75;}.cls-4{fill:#5a5963;}.cls-5{fill:#6c2e7c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 14,
    rx: 2,
    width: 14,
    x: 5,
    y: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 9,
    rx: 2,
    width: 14,
    x: 5,
    y: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10,1h4a2,2,0,0,1,2,2V5a0,0,0,0,1,0,0H8A0,0,0,0,1,8,5V3A2,2,0,0,1,10,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8,19h8a0,0,0,0,1,0,0v2a2,2,0,0,1-2,2H10a2,2,0,0,1-2-2V19A0,0,0,0,1,8,19Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4",
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17,4V3a3,3,0,0,0-3-3H10A3,3,0,0,0,7,3V4A3,3,0,0,0,4,7V17a3,3,0,0,0,3,3v1a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3V20a3,3,0,0,0,3-3V7A3,3,0,0,0,17,4ZM9,3a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V4H9Zm6,18a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V20h6Zm3-4a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V7A1,1,0,0,1,7,6H17a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13,11.586V9a1,1,0,0,0-2,0v3a1,1,0,0,0,.293.707l2,2a1,1,0,0,0,1.414-1.414Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelfastTaxiTourTime);
export default __webpack_public_path__ + "static/media/belfast-taxi-tour-time.c638af968755f25dff7cd427342cbb29.svg";
export { ForwardRef as ReactComponent };